export default __webpack_public_path__ + "static/media/preview.8494a902.svg";